import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fd3ef9a6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3ef9a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd3ef9a6')) {
      api.createRecord('fd3ef9a6', component.options)
    } else {
      api.reload('fd3ef9a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fd3ef9a6&scoped=true", function () {
      api.rerender('fd3ef9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/index.vue"
export default component.exports